import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/auth.service';
import { toast } from 'react-toastify';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      toast.success(response.message);
      setEmailSent(true);
    } catch (error: any) {
      toast.error(
        error.response?.data?.message || 'Failed to send reset link'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h4 className='fw-semibold mb-2'>Forgot Password?</h4>
      <p className='mb-4 text-muted op-7 fw-normal'>
        {emailSent
          ? 'Check your email for a password reset link.'
          : 'Enter your email address and we\'ll send you a link to reset your password.'}
      </p>

      {emailSent ? (
        <div className='alert alert-success' role='alert'>
          <i className='ri-mail-check-line me-2'></i>
          If your email address exists in our system, you will receive a
          password reset link shortly. Please check your inbox and spam folder.
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className='mb-3'>
            <label htmlFor='email' className='form-label'>
              Email Address
            </label>
            <input
              type='email'
              className='form-control form-control-lg'
              id='email'
              name='email'
              placeholder='john@lawfirm.com'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type='submit'
            className='btn btn-primary btn-lg w-100 mb-3'
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className='spinner-border spinner-border-sm me-2'
                  role='status'
                  aria-hidden='true'
                ></span>
                Sending...
              </>
            ) : (
              'Send Reset Link'
            )}
          </button>
        </form>
      )}

      <div className='text-center'>
        <p className='text-muted mt-3'>
          Remember your password?{' '}
          <Link to='/login' className='text-primary fw-semibold'>
            Sign In
          </Link>
        </p>
      </div>

      {emailSent && (
        <div className='text-center mt-3'>
          <button
            className='btn btn-link text-decoration-none'
            onClick={() => {
              setEmailSent(false);
              setEmail('');
            }}
          >
            <i className='ri-arrow-left-line me-1'></i>
            Try a different email
          </button>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;

